import React, { useRef, useState } from 'react';
import { cn } from '@/lib/utils';
import { logoutAuthService } from '@/services/AuthServices';
import { Link } from 'react-router-dom';
import validationErrors from '@/lib/validationErrors';
import { useSelector, useDispatch } from 'react-redux';
import { fileUpload, getFileUrl } from '@/services/CommonService';
import { updateAdminPasswordService, getAdminDataService } from '@/services/AdminServices';
import ToastMe from '@/components/ui/ToastMe';

const LoginUserDropdownMenu = () => {
    const dispatch = useDispatch();
    const imageProperty = useRef(null);
    const { isAuthenticated, userData } = useSelector((state) => state?.Auth);
    const [isLoading, setIsLoading] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const handleFileUpload = (event) => {
        var file_preview = event.target.files[0];
        if (file_preview == '') {
            ToastMe('File is not valid', 'error');
            return true;
        }
        if (event.target.files.length == 0 || (event.target.files.length > 0 && event.target.files[0].type.includes('image/') != true)) {
            ToastMe('Please upload only image files', 'error');
            return true;
        }

        dispatch(fileUpload({ file: file_preview }, 'profile'))
            .then((res) => {
                var formData = res?.data;
                if (formData) {
                    onSubmitImage(userData?._id, {
                        _id: userData?._id,
                        file_name: formData.fileName,
                    });
                }
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
            });
    };

    const onSubmitImage = (editDataId, data) => {
        setIsLoading(true);
        dispatch(updateAdminPasswordService(editDataId, data))
            .then((res) => {
                dispatch(getAdminDataService(editDataId))
                    .then(() => {})
                    .catch(() => {});
                setIsLoading(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsLoading(false);
            });
    };

    const logoutUser = () => {
        setIsLoading(true);
        dispatch(logoutAuthService())
            .then((res) => {
                setIsLoading(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsLoading(false);
            });
    };

    return (
        <div className="dropdown-group">
            <button className="dropdown-btn flex items-center gap-2" onClick={() => setDropdownOpen(!dropdownOpen)}>
                <img
                    className="flex-shrink-0 w-9 h-9 object-cover rounded-lg"
                    ref={imageProperty}
                    onChange={handleFileUpload}
                    accept="image/png, image/jpeg, image/jpg"
                    src={userData?.file_name ? getFileUrl(userData?.file_name, 'profile') : '/assets/images/default/profile-image.jpg'}
                    alt="avatar"
                />
                <h3 className="whitespace-nowrap text-sm capitalize text-left leading-[17px]">
                    hello
                    <b className="block font-semibold">{userData?.name}</b>
                </h3>
                <i className="lab lab-arrow-down text-xs ml-1.5 lab-font-size-14"></i>
            </button>
            <div
                className={cn(
                    'dropdown-list fixed sm:absolute top-[75px] sm:top-12 ltr:right-0 rtl:left-0 z-[60] rounded-xl w-full h-[calc(100vh_-_75px)] overflow-y-auto sm:h-auto sm:w-[360px] p-4 shadow-paper bg-white',
                    dropdownOpen ? 'active' : ''
                )}>
                <div className="w-fit mx-auto text-center mb-5">
                    <figure className="relative z-10 w-[98px] h-[98px] border-2 border-dashed rounded-full inline-flex items-center justify-center border-white bg-gradient-to-t from-[#FF7A00] to-[#FF016C] before:absolute before:top-1/2 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:w-24 before:h-24 before:rounded-full before:-z-10 before:bg-white">
                        <img
                            className="w-[90px] h-[90px] rounded-full shadow-avatar"
                            src={userData?.file_name ? getFileUrl(userData?.file_name, 'profile') : '/assets/images/default/profile-image.jpg'}
                            alt="avatar"
                        />
                    </figure>
                    <label htmlFor="imageProperty" className="block w-11 h-11 mx-auto -mt-7 mb-3 relative z-10 rounded-full border-2 cursor-pointer bg-heading border-white">
                        <input
                            type="file"
                            id="imageProperty"
                            ref={imageProperty}
                            onChange={handleFileUpload}
                            accept="image/png, image/jpeg, image/jpg"
                            className="w-full h-full rounded-full opacity-0 cursor-pointer"
                        />
                        <i className="lab lab-edit-2 absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 -z-10 lab-font-size-24 lab-font-color-1"></i>
                    </label>
                    <h3 className="font-medium text-sm leading-6 capitalize mb-0.5">{userData?.name}</h3>
                    <p className="text-xs mb-0.5">{userData?.email}</p>
                    <p dir="ltr" className="text-xs">
                        +{userData?.phone_no}
                    </p>
                    {/* <h3 className="font-medium text-sm leading-6 capitalize mb-0.5">$ 15,481,41.15</h3> */}
                </div>
                <nav>
                    <Link to={{ pathname: '/admin/profile/edit-profile' }} className="paper-link transition w-full flex items-center gap-3.5 py-3 border-b last:border-none border-[#EFF0F6]">
                        <i className="lab lab-edit lab-font-size-17"></i>
                        <span className="text-sm leading-6 capitalize">edit profile</span>
                    </Link>
                    <Link to={{ pathname: '/admin/profile/change-password' }} className="paper-link transition w-full flex items-center gap-3.5 py-3 border-b last:border-none border-[#EFF0F6]">
                        <i className="lab lab-key lab-font-size-17"></i>
                        <span className="text-sm leading-6 capitalize">change password</span>
                    </Link>
                    <button type="button" onClick={logoutUser} className="paper-link transition w-full flex items-center gap-3.5 py-3 border-b last:border-none border-[#EFF0F6]">
                        <i className="lab lab-logout lab-font-size-17"></i>
                        <span className="text-sm leading-6 capitalize">logout</span>
                    </button>
                </nav>
            </div>
        </div>
    );
};

export default LoginUserDropdownMenu;
